import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { Store } from "@ngrx/store";
import * as $ from "jquery";
import { ToasterService } from "angular2-toaster";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { PurchaseReportService, JGRNService } from "../../../services/index";
import { GrnService } from "../../../services/grn.service";
declare var google;

@Component({
  selector: "approved-Work-Order",
  templateUrl: "fabricStockReport.html",
})
export class fabricStockReport implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  selected = [];
  isLoading: boolean = false;
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  saveEvent: any;
  splitData = {
    no_of_pcs: 0,
  };
  totMtrs: number = 0;
  totalMtrs: number = 0;
  splitArray: any;
  data: any = [];
  splitRowDetails = [];
  splitLength: number = 0;
  filter = {
    groupby: "barcode_wise",
    level: "level1",
    entry_type: "BOTH",
    barcode: "",
    fab_design:"",
  };
  page = {
    limit: 50,
    count: 0,
    offset: 0,
    orderBy: "stock_type, avl_mtrs",
    orderDir: "desc",
  };
  entryTypeList = ["GRN", "JGRN", "BOTH"];
  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("separateFabricTemplate") separateFabricTemplate: TemplateRef<any>;

  columns = [];
  toggleCol = [];
  menu: any;
  reportName = "design_no";
  reportType = "Design";
  user: any;
  total_mtrs: number = 0;
  agentVisible: boolean = false;
  companyInfo: any = [];
  orderList: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private grn: GrnService,
    private jgrnService: JGRNService,
    private purReport: PurchaseReportService
  ) {}

  ngOnInit(): void {
    this.getColumns();
    this.toggleCol = Object.assign({}, this.columns);
  }

  getColumns() {
    if (this.filter.groupby == "barcode_wise") {
      this.columns = [
        {
          name: "SNo",
          prop: "sno",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
          headerClass: "text-center",
          sortable: false,
          cellTemplate: this.snoTemplate,
          toggle: true,
          cellClass: "text-center",
        },
        {
          name: "Barcode",
          prop: "barcode",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Fab.design",
          prop: "fab_design",
          cellClass: "text-left",
          headerClass: "text-left",
          minWidth: 150,
          maxWidth: 150,
          width: 150,
        },
        {
          name: "Shade",
          prop: "shade",
          headerClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Color",
          prop: "color",
          headerClass: "text-left",
          cellClass: "text-left",
          minWidth: 120,
          maxWidth: 120,
          width: 120,
        },
        {
          name: "Party code",
          prop: "party_code",
          headerClass: "text-left",
          cellClass: "text-left",
          minWidth: 140,
          maxWidth: 140,
          width: 140,
        },
        {
          name: "Party design",
          prop: "party_design",
          cellClass: "text-left",
          headerClass: "text-left",
          minWidth: 130,
          maxWidth: 130,
          width: 130,
        },
        {
          name: "Party shade",
          prop: "party_shade",
          headerClass: "text-left",
          cellClass: "text-left",
          minWidth: 100,
          maxWidth: 100,
          width: 100,
        },
        {
          name: "Quality",
          prop: "quality",
          headerClass: "text-left",
          cellClass: "text-left",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Fab type",
          prop: "type",
          headerClass: "text-left",
          cellClass: "text-left",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Entry type",
          prop: "grn_type",
          headerClass: "text-left",
          cellClass: "text-left",
          minWidth: 140,
          maxWidth: 140,
          width: 140,
        },
        {
          name: "Avl mtrs",
          prop: "avl_mtrs",
          headerClass: "text-right",
          cellClass: "text-right",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        // {
        //   name: "Action",
        //   prop: "sno",
        //   minWidth: 80,
        //   maxWidth: 80,
        //   headerClass: "text-center",
        //   width: 80,
        //   sortable: false,
        //   cellTemplate: this.editDeleteTemplate,
        // },
      ];
      let splitMtrs = {
        name: "Split fabric",
        prop: "sno",
        minWidth: 90,
        maxWidth: 90,
        width: 90,
        sortable: false,
        cellTemplate: this.separateFabricTemplate,
      };

      if (this.filter.groupby == "barcode_wise") {
        this.columns.push(splitMtrs);
      }
    }

    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#party_code").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    if (this.menu.param == "fabric_store") {
      this.page.orderBy = "width,tot_mtrs";
      this.page.orderDir = "ASC";
    }
    this.fabricStockReport();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    this.fabricStockReport();
  }

  clearFilter(): void {
    this.applyFilter();
  }

  applyFilter(): void {
    this.fabricStockReport();
  }
  applyFilterView(row) {
    if (this.menu.param == "fabric_store") {
    }
    this.getColumns();
  }
  gobacktoffGroup() {
    if (this.selected.length > 0) {
      swal("Please deselect all before going back");
      return;
    }

    this.getColumns();
  }
  fabricStockReport(): void {
    let params = {
      start: `${this.page.offset * this.page.limit}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      filter: JSON.stringify(this.filter),
      //order_from_date:this.filter.order_from_date
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.purReport
      .getFabricStockReport(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.orderList = res.data;
        that.totMtrs = res.tot_mtrs;

        that.total_mtrs = 0;
        that.orderList.forEach((el) => {
          that.total_mtrs += el.avl_mtrs;
          el.barcode = el.barcode.toString().padStart(6, "0");
        });
        that.total_mtrs =
          Math.round((that.total_mtrs + Number.EPSILON) * 100) / 100;
      });
  }

  splitRow(row) {
    this.splitData = {
      no_of_pcs: 0,
    };
    this.totalMtrs = 0;
    this.splitArray = [];
    this.splitRowDetails = [];
    this.splitLength = 0;

    this.splitRowDetails = row;
    this.splitLength = Object.keys(this.splitRowDetails).length;
  }

  onEnterNoOfBits(bits) {
    this.splitArray = Array(bits).fill(bits);
  }
  calcPcsMtrs(bit) {
    this.totalMtrs += Number(bit);
  }

  onEnterSplit() {
    let that = this;

    if (Number(that.totalMtrs.toFixed(2)) != Number(that.splitRowDetails["avl_mtrs"])) {
      swal("Please tally splitted pieces with original piece");
      return;
    }

    let params = {
      splitData: JSON.stringify(that.splitData),
      splitRow: JSON.stringify(that.splitRowDetails),
    };
    swal({
      title: "Are you sure to split this barcode?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes!",
      cancelButtonText: "No",
    })
      .then(() => {
        that.isLoadMask = that.purReport
          .splitFabricPieces(params)
          .then((res: any) => {
            if (res.success) {
              that.toasterService.pop({
                bodyOutputType: 1,
                type: "success",
                title: "SUCCESS",
                body: res.message,
              });
              swal({
                title: "Click 'YES' for Sticker Print?",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "YES!",
                cancelButtonText: "NO",
              })
                .then(() => {
                  that.loadeditFabriclist(res.split_id, res.stock_type);
                })
                .catch(() => {});
            } else {
              swal("SOMETHING WENT WRONG");
            }
          });
      })
      .catch(() => {});
  }

  loadeditFabriclist(split_id, stock_type) {
    let params = {
      split_id: split_id,
      stock_type: stock_type,
    };
    this.purReport.getEditSplitList(params).then((res: any) => {
      this.clickPrint(res.data[0], res.data, stock_type);
      this.data = res.data;
    });
  }

  clickPrint(row, data, stock_type) {
    let that = this;
    let params: any = Object.assign({}, row);
    params["data"] = JSON.stringify(data);
    if (stock_type == "GRN") {
      that.isLoadMask = that.grn
        .grnprint(params)
        .then(function (res: any) {
          $("#barcodeShow").modal("show");
          that.getColumns();
        })
        .catch(() => {});
    } else {
      that.isLoadMask = that.jgrnService
        .jgrnprint(params)
        .then(function (res: any) {
          $("#barcodeShow").modal("show");
          that.getColumns();
        })
        .catch(() => {});
    }
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/fabricStockReport/fabricStockReport.ts